module.exports = __webpack_public_path__ + "static/media/darkgrey.57024ad9.png";